import { render, staticRenderFns } from "./TxList.vue?vue&type=template&id=e551c154&"
import script from "./TxList.vue?vue&type=script&lang=js&"
export * from "./TxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports